module.exports = __webpack_public_path__ + "static/Charles River-69a6535b172a4681a7be4a08c1f22593.jpg";